import { UserSummariesReportColumn } from '@vacationtracker/shared/types/export'
import { COLUMN_IDS } from './columnIds'

const EXPORT_KEY_BY_COLUMN_ID: Record<string, UserSummariesReportColumn> = {
  [COLUMN_IDS.team]: 'department',
  [COLUMN_IDS.role]: 'roles',
}

export interface IBuildExportColumnsParams {
  profileColumns: string[]
  leaveColumns: string[]
}

export function buildExportColumns(params: IBuildExportColumnsParams): string[] {
  const { profileColumns, leaveColumns } = params
  const mapped = [...profileColumns, ...leaveColumns].map((id) => EXPORT_KEY_BY_COLUMN_ID[id] ?? id)
  return ['user', ...mapped].filter((key, index, all) => all.indexOf(key) === index)
}
